<template>
  <button
    :class="['btn-multi', positionClass, chevronForwardClass]"
    @click="onClick"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ButtonMulti',
  props: {
    single: {
      type: Boolean,
      required: false,
      default: false
    },
    position: {
      type: String,
      required: false,
      default: ''
    },
    chevronForward: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    positionClass() {
      return this.single ? 'btn-multi--single' : `btn-multi--${this.position}`
    },
    chevronForwardClass() {
      return { 'chevron--forward--black': this.chevronForward }
    }
  },
  methods: {
    onClick() {
      this.$emit('click-button')
    }
  }
}
</script>
